import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../App.css';
import PageHeader from '../../components/PageHeader';
import MyMembershipsPanel from '../../components/MyMembershipsPanel';

const MyMembershipsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="admin-list-page">
      <PageHeader title={t('memberships.myTitle')} />
      <MyMembershipsPanel />
    </div>
  );
};

export default MyMembershipsPage;
